interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://hmanga.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 px-4 md:px-6">
        {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-600"></i>
            )}
            {item.href ? (
              <a href={item.href} className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                {item.label}
              </a>
            ) : (
              <span className="text-foreground-300">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}